export default "__VITE_ASSET__Z8PYrlU7__"